import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Vite inlines `import.meta.env.VITE_*` at build time, so these are
// embedded as plain strings in the bundle — no globals, no `define`.
// In Replit dev, `vite.config.ts` shims them from the unprefixed
// `SUPABASE_URL` / `SUPABASE_ANON_KEY` env vars so the existing
// workflow keeps working.
const rawUrl = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!rawUrl || !anonKey) {
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required. " +
      "On Vercel, set them in the project's Environment Variables. " +
      "On Replit, set SUPABASE_URL and SUPABASE_ANON_KEY (the dev " +
      "config shims them across).",
  );
}

// Normalise to the project origin: the dashboard sometimes surfaces
// the URL with a trailing `/rest/v1/` path which would otherwise be
// concatenated onto the SDK's own `/auth/v1/...` paths.
const url = new URL(rawUrl).origin;

export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
